import React from 'react';
import styled from 'styled-components';

import { Container } from '@nfs-react/components';

import { useText } from 'hooks';
import { BackgroundVideo } from 'helpers/components';
import { MOBILE, TABLET, DESKTOP } from 'helpers/styles/media';

const Top = () => {
  return (
    <TopWrapper>
      <TopContainer>
        <TopInner>
          <TopT1>{useText('top__t1', true)}</TopT1>
          <TopT2>{useText('top__t2', true)}</TopT2>
        </TopInner>
      </TopContainer>
      <VideoWrap>
        <BackgroundVideo
          srcSet={[
            {
              slug: 'desktop-video',
              media: DESKTOP,
            },
            {
              slug: 'tablet-video',
              media: TABLET,
            },
            {
              slug: 'mobile-video',
              media: MOBILE,
            },
          ]}
        />
      </VideoWrap>
    </TopWrapper>
  );
};

const TopWrapper = styled.section`
  position: relative;
  background-position: center top;
  background-repeat: no-repeat;
  background-color: #ffffff;

  @media ${DESKTOP} {
    min-height: 758px;
  }

  @media ${TABLET} {
    min-height: 584px;
  }

  @media ${MOBILE} {
    min-height: 540px;
  }
`;

const TopContainer = styled(Container)`
  position: relative;
  z-index: 2;
`;

const TopInner = styled.div`
  position: absolute;
  width: 900px;
  top: 140px;
  right: 15px;
  background: #181818;
  border-radius: 30px;
  padding: 35px 35px 80px 100px;

  @media ${TABLET} {
    width: 955px;
    top: 62px;
    right: calc(50% - 605px);
    border-radius: 30px 0 0 30px;
    padding: 37px 247px 67px 96px;
  }

  @media ${MOBILE} {
    width: 540px;
    top: 102px;
    right: calc(50% - 385px);
    border-radius: 30px 0 0 30px;
    padding: 16px 222px 20px 93px;
  }

  &:before {
    content: '';
    display: block;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: ${({ theme: { imgUrl } }) =>
    imgUrl('shield.png', false, false)};
    width: 307px;
    height: 360px;
    position: absolute;
    bottom: -16px;
    left: 76px;

    @media ${TABLET} {
      bottom: -31px;
      left: -79px;
    }

    @media ${MOBILE} {
      width: 195px;
      height: 228px;
      transform: rotate(4deg);
      bottom: -77px;
      left: -63px;
    }
  }
`;

const TopT1 = styled.div`
  font-weight: 900;
  font-size: 70px;
  line-height: 118%;
  text-align: right;
  letter-spacing: 0.02em;
  color: #ffd753;
  margin-bottom: 25px;

  @media ${TABLET} {
    font-size: 60px;
  }

  @media ${MOBILE} {
    font-size: 36px;
    line-height: 106.1%;
    margin-bottom: 18px;
  }
`;

const TopT2 = styled.div`
  font-weight: 500;
  font-size: 31px;
  line-height: 143%;
  text-align: right;
  letter-spacing: 0.02em;
  color: #ffffff;
  max-width: 525px;

  @media ${TABLET} {
    font-size: 29px;
  }

  @media ${MOBILE} {
    font-size: 20px;
    line-height: 131%;
    letter-spacing: -0.01em;
  }
`;

const VideoWrap = styled.div`
  position: relative;
  z-index: 1;

  @media (min-width: 1921px) {
    width: 1920px;
    margin: auto;
  }

  @media ${DESKTOP} {
    height: 756px;
  }

  @media ${TABLET} {
    height: 584px;

    video {
      object-position: left;
    }
  }

  @media ${MOBILE} {
    height: 540px;
  }
`;

export default Top;
